import Vue from 'vue'
import NuxtLoading from './components/nuxt-loading.vue'


let layouts = {

  "_default": () => import('../src/layouts/default.vue'  /* webpackChunkName: "layouts/default" */).then(m => m.default || m)

}

let resolvedLayouts = {}

export default {
  head: {"title":"大搜车 - 汽车流通商的坚定赋能者","titleTemplate":"%s - 大搜车","meta":[{"hid":"keywords","name":"keywords","content":"大搜车,搜车,souche,dasouche,汽车新零售,买车,卖车,二手车,新车,弹个车,二手车估价,卖车估价,SaaS,4S店,主机厂,新车二网,大风车,车牛,车行168,运车管家,卖车管家,布雷克索,车易拍,秒贷,汽车直播,经销商系统,二手车管理系统,一鹿有车,二手车消费贷,新车消费贷,二手车商,软件服务,268V,二手车估价"},{"hid":"description","name":"description","content":"大搜车通过先进运营系统和完善交易服务，让车商经营更方便、交易更高效。"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"大搜车"},{"hid":"og:image","name":"og:image","property":"og:image","content":"https:\u002F\u002Fwww.souche.com\u002Ficon.png"},{"hid":"image","name":"image","property":"image","content":"https:\u002F\u002Fwww.souche.com\u002Ficon.png"}],"link":[],"style":[],"script":[]},
  render(h, props) {
    const loadingEl = h('nuxt-loading', { ref: 'loading' })
    const layoutEl = h(this.layout || 'nuxt')
    const templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [ layoutEl ])

    const transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      }
    }, [ templateEl ])

    return h('div',{
      domProps: {
        id: '__nuxt'
      }
    }, [
      loadingEl,
      transitionEl
    ])
  },
  data: () => ({
    layout: null,
    layoutName: ''
  }),
  beforeCreate () {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt)
  },
  created () {
    // Add this.$nuxt in child instances
    Vue.prototype.$nuxt = this
    // add to window so we can listen when ready
    if (typeof window !== 'undefined') {
      window.$nuxt = this
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error
  },
  
  mounted () {
    this.$loading = this.$refs.loading
  },
  watch: {
    'nuxt.err': 'errorChanged'
  },
  
  methods: {
    
    errorChanged () {
      if (this.nuxt.err && this.$loading) {
        if (this.$loading.fail) this.$loading.fail()
        if (this.$loading.finish) this.$loading.finish()
      }
    },
    
    setLayout (layout) {
      if (!layout || !resolvedLayouts['_' + layout]) layout = 'default'
      this.layoutName = layout
      let _layout = '_' + layout
      this.layout = resolvedLayouts[_layout]
      return this.layout
    },
    loadLayout (layout) {
      if (!layout || !(layouts['_' + layout] || resolvedLayouts['_' + layout])) layout = 'default'
      let _layout = '_' + layout
      if (resolvedLayouts[_layout]) {
        return Promise.resolve(resolvedLayouts[_layout])
      }
      return layouts[_layout]()
      .then((Component) => {
        resolvedLayouts[_layout] = Component
        delete layouts[_layout]
        return resolvedLayouts[_layout]
      })
      .catch((e) => {
        if (this.$nuxt) {
          return this.$nuxt.error({ statusCode: 500, message: e.message })
        }
      })
    }
  },
  components: {
    NuxtLoading
  }
}




// WEBPACK FOOTER //
// ./.nuxt/App.js